import { io } from 'socket.io-client';
import { BASE_URL } from '../constants/BaseUrl';

/**
 * Create a socket.io client instance with JWT authentication
 * @param {string} token - JWT access token
 * @returns {import('socket.io-client').Socket} Socket instance
 */
export const createSocket = (token) => {
  // Remove trailing slash from BASE_URL if present
  const baseUrl = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL;
  
  // Socket.io connects to the /chat namespace
  const socketUrl = baseUrl.replace(/\/$/, '');
  
  const socket = io(`${socketUrl}/chat`, {
    auth: {
      token: token,
    },
    transports: ['polling', 'websocket'], // Try polling first for better AppRunner compatibility
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    timeout: 20000,
    upgrade: true,
    rememberUpgrade: true,
  });

  return socket;
};

